var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"dismissible":"","type":_vm.alertdata.type},model:{value:(_vm.alertdata.show),callback:function ($$v) {_vm.$set(_vm.alertdata, "show", $$v)},expression:"alertdata.show"}},[_vm._v("\n  "+_vm._s(_vm.alertdata.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }